import React from 'react';
import { Card, Button, message } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';

const RegistrationFailed: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paymentId = searchParams.get('payment_id');

  return (
    <div style={{ maxWidth: '600px', margin: '50px auto', padding: '24px' }}>
      <Card style={{ textAlign: 'center' }}>
        <CloseCircleOutlined style={{ fontSize: '64px', color: '#ff4d4f', marginBottom: '24px' }} />

        <h1 style={{ color: '#ff4d4f', marginBottom: '16px' }}>
          Payment Failed
        </h1>

        <p style={{ marginBottom: '24px', color: '#666' }}>
          Unfortunately, your payment could not be processed. This could be due to:
        </p>

        <ul style={{ textAlign: 'left', margin: '16px 0 24px 0', color: '#666' }}>
          <li>Insufficient funds</li>
          <li>Card declined by bank</li>
          <li>Payment method issue</li>
          <li>Temporary network issue</li>
        </ul>

        <div style={{ background: '#fff2f0', padding: '16px', borderRadius: '4px', marginBottom: '24px' }}>
          <p><strong>Don't worry!</strong> Your registration details are saved.</p>
          <p>You can try the payment again or contact support if the issue persists.</p>
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Button type="primary" onClick={() => navigate('/register')}>
            Try Again
          </Button>

          <Button onClick={() => navigate('/contact')}>
            Contact Support
          </Button>
        </div>

        {paymentId && (
          <div style={{ marginTop: '24px', fontSize: '12px', color: '#999' }}>
            Payment ID: {paymentId}
          </div>
        )}
      </Card>
    </div>
  );
};

export default RegistrationFailed;